<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret" /></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'" />
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label class="form-label">Location *</label>
              <auto-complete
                :dataset="locationSearchResults"
                title="Origin Location"
                placeHolder="Type to search"
                :initVal="entity.location"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectLocation"
              />
            </div>
            <div class="form-group">
              <label for="service" class="form-label">Service *</label>
              <select class="form-control" id="service" v-model="entity.service">
                <option value=""/>
                <option v-for="(opt, i) in serviceTypes" :value="opt.code">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="rate" class="form-label">Rate *</label>
              <div class="input-group">
                <input class="form-control" id="rate" v-model="entity.rate"/>
                <span class="input-group-addon">%</span>
              </div>
            </div>
<!--            <div class="form-group">-->
<!--              <label for="rate-currency" class="form-label">Rate Currency</label>-->
<!--              <select class="form-control" id="rate-currency" v-model="entity.rateCurrency">-->
<!--                <option value=""></option>-->
<!--                <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>-->
<!--              </select>-->
<!--            </div>-->
            <div class="form-group">
              <label :for="'is-state-' + i" class="form-label">Advice only?</label>
              <div class="material-switch">
                <input :id="'is-state-' + i" type="checkbox" v-model="entity.adviceOnly"/>
                <label :for="'is-state-' + i" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="suspended" class="form-label">Suspended?</label>
              <div class="material-switch">
                <input id="suspended" type="checkbox" v-model="entity.suspended"/>
                <label for="suspended" class="label-success"></label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="calc-tu" class="form-label">Brand</label>
              <select class="form-control" id="calc-tu" v-model="entity.brand">
                <option value=""/>
                <option v-for="(opt, i) in brands" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="date-from" class="form-label">Effective From</label>
              <input id="date-from" class="mai-date" type="date" v-model="entity.effectiveFrom"/>
            </div>
            <div class="form-group">
              <label for="date-to" class="form-label">Effective To</label>
              <input id="date-to" class="mai-date" type="date" v-model="entity.effectiveTo"/>
            </div>
            <div class="form-group">
              <label for="location-comments" class="form-label">Note</label>
              <textarea class="form-control" rows="5" id="location-comments" v-model="entity.note"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import AutoComplete from '../../../helpers/AutoComplete.vue'
  import QuoteTaxMixin from './mixin'
  export default {
    name: 'QuoteTax',
    mixins: [AdminEntityMixin, HelperMixin, QuoteTaxMixin],
    components: {
      AutoComplete
    },
    data () {
      return {
        transformForUpdate: {
          brand: this.toMinus
        },
        newEntityScreen: 'Admin - Quote Taxes',
        editEntityScreen: 'Admin - Edit/View Quote Tax',
        boxes: [
          {
            prop: 'brand',
            id: 'id'
          },
          {
            prop: 'rateCurrency',
            id: 'id'
          },
          {
            prop: 'service',
            id: 'code'
          }
        ],
        tab: 'main',
        entityName: 'quote-tax',
        entity: {
          id: null,
          adviceOnly: null,
          effectiveFrom: null,
          effectiveTo: null,
          brand: null,
          location: null,
          rate: null,
          rateCurrency: null,
          service: null
        },
        brand: '',
        onLoadTransformations: {
          effectiveFrom: this.fromTimestamp,
          effectiveTo: this.fromTimestamp
        },
        effectiveTo: {
          time: window.getYMDDate()
        },
        effectiveFrom: {
          time: window.getYMDDate()
        }
      }
    },
    watch: {
      'effectiveTo.time' (newVal, oldVal) {
        if (this.entity.effectiveTo !== newVal) {
          this.entity.effectiveTo = newVal
        }
      },
      'effectiveFrom.time' (newVal, oldVal) {
        if (this.entity.effectiveFrom !== newVal) {
          this.entity.effectiveFrom = newVal
        }
      },
      'entity.effectiveFrom' (newVal, oldVal) {
        if (this.effectiveFrom.time !== newVal) {
          this.effectiveFrom.time = newVal
        }
      },
      'entity.effectiveTo' (newVal, oldVal) {
        if (this.effectiveTo.time !== newVal) {
          this.effectiveTo.time = newVal
        }
      }
    },
    computed: {
      isValid () {
        return this.entity.location && this.entity.location.id &&
          this.entity.service &&
          this.entity.rate !== null
      },
      brands () {
        return this.filterOptions('BRAND')
      }
    },
    methods: {
      selectLocation (o) {
        this.entity.location = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      filterOptions (code) {
        return this.systemOptions.filter(({optionType}) => optionType !== null && optionType.hasOwnProperty('code') && optionType.code === code)
      },
      getBaseData () {
        return {
          id: null,
          adviceOnly: null,
          effectiveFrom: window.getYMDDate(),
          effectiveTo: window.getYMDDate(),
          brand: null,
          location: null,
          rate: null,
          rateCurrency: null,
          service: null,
          note: null
        }
      },
      updateEntity (prop, method, val) {
        this.entity[prop] = this[method](val)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/QuoteTax/QuoteTax.vue